import React from 'react'
import { connect } from 'react-redux'
import {
  Box, IconButton, ListItem, ListItemIcon, ListItemText, Tooltip
} from '@mui/material'
import { HelpOutline } from '@mui/icons-material'

const ManualButton = ({ browser: { mobile } }) => {
  if (!mobile) {
    return (
      <Box>
        <Tooltip title="マニュアル">
          <span>
            <IconButton size="large" color="inherit"
                        className="open-help-button"
                        href="/manual" target="_blank" rel="noopener">
              <HelpOutline />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    )
  } else {
    return (
      <ListItem button component="a" href="/manual" target="_blank" rel="noreopen">
        <ListItemIcon><HelpOutline /></ListItemIcon>
        <ListItemText>マニュアル</ListItemText>
      </ListItem>
    )
  }
}

export default connect(
  state => ({
    browser: state.browser
  })
)(ManualButton)
